module.exports = __webpack_public_path__ + "static/media/11.9fb2baa5.png";